import { startCase, toLower } from 'lodash';
export interface NameUtil {
  getFullName: (firstName: string, lastName: string) => string;
}

export function useName(): NameUtil {
  const getFullName = (firstName: string, lastName: string): string => {
    return startCase(toLower(`${firstName} ${lastName}`));
  };

  return { getFullName: getFullName };
}
